import React, { useEffect, useState } from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { checkoutUrl } from '../data/copy';
import { trackPixelEvent } from '../utils/metaPixel';

/**
 * Scorciatoia d'acquisto sempre visibile su schermi piccoli: compare dopo
 * l'header e si nasconde sopra la sezione dell'offerta.
 *
 * La visibilità è controllata con IntersectionObserver (nessuna lettura di
 * layout a ogni scroll), quindi non forza mai un reflow sincrono.
 */
export function StickyCta() {
  const [isPastHero, setIsPastHero] = useState(false);
  const [isOnOffer, setIsOnOffer] = useState(false);
  useEffect(() => {
    const hero = document.querySelector('header');
    const offer = document.getElementById('oferta');
    const heroObserver = new IntersectionObserver(([entry]) => setIsPastHero(!entry.isIntersecting), {
      threshold: 0
    });
    if (hero) heroObserver.observe(hero);
    const offerObserver = new IntersectionObserver(([entry]) => setIsOnOffer(entry.isIntersecting), {
      threshold: 0
    });
    if (offer) offerObserver.observe(offer);
    return () => {
      heroObserver.disconnect();
      offerObserver.disconnect();
    };
  }, []);
  const isVisible = isPastHero && !isOnOffer;
  return <div className={`fixed inset-x-0 bottom-0 z-40 border-t border-line bg-paper-soft px-4 py-3 transition-[opacity,transform] duration-200 ease-out sm:hidden ${isVisible ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-3 opacity-0'}`} data-id="element-201" data-mp="gwgyhms50y38">
      <a href={checkoutUrl} onClick={() => trackPixelEvent('InitiateCheckout', {
      content_name: 'Pallamano 360',
      value: 19,
      currency: 'EUR'
    })} className="flex w-full items-center justify-center gap-2.5 rounded-xl bg-ember px-6 py-3.5 font-display text-base font-semibold uppercase tracking-[0.06em] text-paper-soft transition-colors duration-150 ease-out hover:bg-ember-hover focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ember" data-id="element-202" data-mp="lus75u6p52jv">
        Accedi al sistema completo ora
        <ArrowRightIcon className="h-4 w-4 shrink-0" strokeWidth={2.4} aria-hidden="true" data-id="element-203" data-mp="10l0380c7w6ay" />
      </a>
    </div>;
}